import React from 'react';

export const QuarterThreeShape = ({ color }: { color: string }) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100 0L100 100L0 100C0 44.7715 44.7715 0 100 0Z"
      fill={color}
    />
  </svg>
);
